import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingLeft: 25,
        paddingRight: 25
    },
    contentTitle: {
        flexDirection: 'row',
        marginTop: 25
    },
    title: {
        fontSize: 18,
        color: '#32BFB1',
        fontWeight: 'bold',
        marginLeft: 15
    },
    list: {
        marginTop: 20
    },
    itemList: {
        cursor: 'pointer',
    },
    contentItemList: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    textItemList: {
        fontSize: 15,
        color: '#2C2C2E',
        marginTop: 3
    },
    hrLine: {
        height: 0.5,
        width: '100%',
        position: 'relative',
        borderWidth: 0.8,
        marginTop: 10,
        marginBottom: 10,
        borderColor: "rgba(44, 44, 46, 0.5)",
    },
    textLogout: {
        textAlign: 'center',
        marginTop: 50,
        marginBottom: 10,
        fontSize: 16,
        fontWeight: '400'
    }
});

export default styles;
